import createIcon from './createIcon';

export default createIcon(require('./email.svg'));